// TODO optimize ProtectedRoute logic
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export function ProtectedRoute({ children, protectedBy, redirectPath = '/auth' }) {
  const location = useLocation();
  // Dynamically check token from localStorage to handle auth state changes
  const token = localStorage.getItem('token');
  const iframeToken = localStorage.getItem('iframeToken');
  const embedToken = localStorage.getItem('embed_access_token'); // New embed token
  const userType = localStorage.getItem('userType');
  // Accept both admin and org_admin as root roles
  const isRoot = userType === 'admin' || userType === 'org_admin';
  const isIframe = userType === 'iframe';
  const isEmbed = !!embedToken; // Check for embed mode

  let isAllowed = false;

  if (protectedBy === 'guest') {
    isAllowed = !token && !iframeToken && !embedToken;
  } else if (protectedBy === 'root') {
    isAllowed = !!(token && isRoot);
  } else if (protectedBy === 'iframe') {
    // Accept both old iframeToken and new embed token
    isAllowed = !!((iframeToken && isIframe) || embedToken);
  } else if (protectedBy === 'token-auth') {
    isAllowed = !!(token && (isRoot || isIframe));
  } else if (protectedBy === 'any-auth') {
    isAllowed = !!((token && isRoot) || (iframeToken && isIframe) || embedToken);
  } else if (protectedBy === 'non-iframe') {
    isAllowed = !iframeToken;
  } else if (protectedBy === 'always') {
    isAllowed = true;
  } else if (typeof protectedBy === 'boolean') {
    isAllowed = protectedBy;
  }

  if (isAllowed) {
    return children;
  }

  // Determine redirect path dynamically
  let finalRedirectPath = redirectPath;
  if (isRoot && token) {
    finalRedirectPath = '/projects';
  } else if (isIframe && iframeToken) {
    finalRedirectPath = '/search';
  } else {
    finalRedirectPath = '/auth';
  }

  return <Navigate to={finalRedirectPath} replace />;
}
